import {makeTrackEvent} from './makeTrackEvent';

export type WorkspaceModesAction =
  | 'Auto workspace created'
  | 'Manual workspace created'
  | 'Docs link clicked';
export const trackWorkspaceModes = makeTrackEvent<
  {
    action: WorkspaceModesAction;
    location?: string;
  },
  {
    action: {
      description: 'the interaction that occurred';
    };
    location: {
      description: 'clarify where the action occurred (optional)';
    };
    _description: 'Tracks interactions related to workspace modes';
    _location: 'Workspaces';
    _motivation: 'Understand workspace mode usage';
  }
>('Workspace modes');
